import { Component, output } from '@angular/core';

@Component({
  selector: 'app-close-button',
  standalone: true,
  template: `
    <button type="button" class="textHelpercolorone cursor-pointer" (click)="closed.emit()" aria-label="Close">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </button>
  `,
})
export class CloseButtonComponent {
  closed = output<void>();
}